var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaChalkboardTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:chalkboard-teacher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 13.125V17.5H56.875V52.5H26.25V56.875H65.625V52.5H61.25V13.125H8.75ZM17.5044 19.6875C15.1858 19.6956 12.9644 20.6199 11.3245 22.259C9.68466 23.898 8.75922 26.1189 8.75 28.4375C8.75 33.2478 12.6962 37.1875 17.5044 37.1875C19.8218 37.1783 22.0416 36.2533 23.6798 34.6142C25.3181 32.9752 26.2419 30.7549 26.25 28.4375C26.25 23.6316 22.3081 19.6875 17.5044 19.6875ZM30.625 21.875V26.25H41.5625V21.875H30.625ZM45.9375 21.875V26.25H52.5V21.875H45.9375ZM17.5044 24.0625C19.9412 24.0625 21.875 25.9941 21.875 28.4375C21.875 30.8875 19.9434 32.8125 17.5044 32.8125C15.0544 32.8125 13.125 30.8875 13.125 28.4375C13.125 25.9941 15.0566 24.0625 17.5044 24.0625ZM30.625 30.625V35H52.5V30.625H30.625ZM8.75 39.375V56.875H13.125V43.75H19.6875V56.875H24.0625V45.1894L28.5775 47.5781C29.8572 48.2562 31.395 48.2541 32.6725 47.5781V47.5825L40.3944 43.4984L38.3534 39.6266L30.6294 43.7106L23.8569 40.1362C22.9117 39.6369 21.859 39.3756 20.79 39.375H8.75Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaChalkboardTeacher);
export default __webpack_public_path__ + "static/media/la_chalkboard-teacher.20c513947022afcf1fa3ebc205626f19.svg";
export { ForwardRef as ReactComponent };